import { Collapse } from '@nexelem/deprecated-theme';
import { useState } from 'react';
import { WorkerAvailability, WorkerCapabilities } from '../../brigadeComponents';
import { Tasks } from '../../modals/AssignWorkerModal/Tasks';
import { useCustomTranslation } from '../../../../../hooks';
import { WorkerAvatar } from '../../modals/AssignWorkerModal/WorkerAvatar';
import { ResourceAvailabilityMeta } from '@nexelem/graphne-api';
import { AddTaskButton } from './AddTaskButton';
import { DateRange } from './ShiftSelector';

type DrawerWorkerProps = {
  data: ResourceAvailabilityMeta;
  dateRange?: DateRange;
};

export const DrawerWorker = ({ data, dateRange }: DrawerWorkerProps) => {
  const { tWrapper } = useCustomTranslation('products.productionPlan');

  const { capabilities, availabilities, tasks } = data.resource;
  const [isOpen, setOpen] = useState(false);

  return (
    <div className="mt-2 rounded-xs border border-border-container bg-surface-container-lighter">
      <div className="flex items-center gap-2 py-4 pr-1 pl-3">
        <WorkerAvatar data={data} isOpen={isOpen} setOpen={() => setOpen(!isOpen)} />
      </div>
      <Collapse in={isOpen}>
        <div className="border-t border-border-container px-4 py-3">
          <WorkerCapabilities capabilities={capabilities} className="mb-6" />
          <WorkerAvailability availabilities={availabilities} className="mb-6 gap-4" />
          <div className="mb-2 text-t14-sb text-text-secondary-darker">{tWrapper('tasks')}</div>
          <AddTaskButton dateRange={dateRange} workerData={data.resource} />
          <Tasks isDrawer tasks={tasks} workerData={data.resource} />
        </div>
      </Collapse>
    </div>
  );
};
